export default __webpack_public_path__ + "img/64266af3d84326f03c214ffa1e0a068e.svg";